import { render, staticRenderFns } from "./assignOrganization.vue?vue&type=template&id=9f90a16e&scoped=true&"
import script from "./assignOrganization.vue?vue&type=script&lang=js&"
export * from "./assignOrganization.vue?vue&type=script&lang=js&"
import style0 from "./assignOrganization.vue?vue&type=style&index=0&id=9f90a16e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f90a16e",
  null
  
)

export default component.exports